import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import SERVICES from '@/constants/services';
import moment from 'moment';
export default Vue.extend({
    name: 'confirmTransferPopupChunk',
    data: () => ({
        step: 1,
        requestAwait: false,
        hasWhiteListSecret: true,
        form: {
            fields: {
                secretCode: {
                    valid: false,
                    value: '',
                    type: 'password',
                    rules: [
                        (v) => Boolean(v.length) || 'Поле обязательно'
                    ]
                },
                smsCode: {
                    valid: false,
                    value: '',
                    codeSendError: false,
                    codeIsSent: false,
                    codeSentBefore: false,
                    loading: false,
                    retryTimeout: 60,
                    retries: 3,
                    letRetry: false,
                    rules: [
                        (v) => Boolean(v.length) || 'Поле обязательно'
                    ]
                }
            }
        },
        GAForm: {
            valid: false,
            fields: {
                GACode: {
                    value: '',
                    rules: [
                        (v) => Boolean(v) || 'Поле обязательно',
                        (v) => v.length === SERVICES.CODE_LENGTH || `${SERVICES.CODE_LENGTH}-значный код`
                    ],
                    errorsBucket: []
                }
            }
        }
    }),
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    watch: {
        'form.fields.smsCode.retryTimeout'(v) {
            const vm = this;
            if (v > 0) {
                setTimeout(() => {
                    vm.form.fields.smsCode.retryTimeout = v - 1;
                }, 1000);
            }
            else
                vm.form.fields.smsCode.letRetry = true;
        }
    },
    created() {
        this.checkWhitelistSecret();
    },
    methods: {
        checkWhitelistSecret() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield this.services.mainService.checkWhitelistSecret(null);
                this.hasWhiteListSecret = response.data.walletSecret;
            });
        },
        toggleSecretAppear() {
            const vm = this;
            vm.form.fields.secretCode.type = vm.form.fields.secretCode.type === 'password' ? 'text' : 'password';
        },
        sendSMS() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.smsCode.loading = true;
                vm.form.fields.smsCode.codeSentBefore = false;
                const response = yield vm.services.mainService.sendSMS(null, SERVICES.SMS_OPERATIONS.transfers.withdrawRequest);
                if (response.success) {
                    vm.form.fields.smsCode.loading = false;
                    vm.form.fields.smsCode.codeIsSent = true;
                    vm.form.fields.smsCode.letRetry = false;
                    vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                    vm.form.fields.smsCode.retries -= 1;
                    setTimeout(() => {
                        vm.form.fields.smsCode.retryTimeout -= 1;
                    }, 1000);
                }
                else {
                    vm.form.fields.smsCode.loading = false;
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.repeatAfter) {
                        vm.form.fields.smsCode.codeSentBefore = true;
                        vm.form.fields.smsCode.codeIsSent = true;
                        vm.form.fields.smsCode.letRetry = false;
                        vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                        vm.form.fields.smsCode.retries -= 1;
                        setTimeout(() => {
                            vm.form.fields.smsCode.retryTimeout -= 1;
                        }, 1000);
                    }
                    else {
                        vm.form.fields.smsCode.codeSendError = true;
                        vm.form.fields.smsCode.letRetry = true;
                    }
                }
            });
        },
        handleClickRestartProcess() {
            window.location.reload();
        }
    }
});
